import { render, staticRenderFns } from "./UserVerificationBadge.htm?vue&type=template&id=caa2479e&scoped=true&"
import script from "./UserVerificationBadge.ts?vue&type=script&lang=js&"
export * from "./UserVerificationBadge.ts?vue&type=script&lang=js&"
import style0 from "./UserVerificationBadge.scss?vue&type=style&index=0&id=caa2479e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa2479e",
  null
  
)

export default component.exports